import CryptoJS from "crypto-js";


export const API_URL = process.env.REACT_APP_API_URL;
console.log("🚀 ~ API_URL:", API_URL);
export const LOGIN_API = `${API_URL}/api/user/login`;
export const SIGN_UP_API = `${API_URL}/api/user/signup`;
export const GET_CONNECTION = `${API_URL}/api/connection`;
export const GET_MAPPING = `${API_URL}/api/mapping/connection`;
export const CREATE_MAPPING = `${API_URL}/api/mapping`;
export const UPDATE_MAPPING = `${API_URL}/api/mapping`;
export const DELETE_MAPPING = `${API_URL}/api/mapping`;
export const DELETE_CONNECTION_MAPPING = `${API_URL}/api/mapping/connection`;

export const CREATE_CONNECTION = `${API_URL}/api/connection`;
export const DELETE_CONNECTION = `${API_URL}/api/connection`;
export const CREATE_DESTINATION = `${API_URL}/api/destination`;
export const UPDATE_DESTINATION = `${API_URL}/api/destination`;
export const DELETE_DESTINATION = `${API_URL}/api/destination`;
export const CREATE_SOURCE = `${API_URL}/api/source`;
export const GET_SOURCE = `${API_URL}/api/source`;
export const UPDATE_SOURCE = `${API_URL}/api/source`;
export const DELETE_SOURCE = `${API_URL}/api/source`;

export const GET_AUTHENTICATION = `${API_URL}/authenctication`;
export const CHANGE_PASSWORD = `${API_URL}/api/user/resetPassword`;

const SECRET_KEY = "$#e21e)&^#@!!@#"; 


export const decryptData = (encryptedData) => {
    const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  };

  
